<template>
  <v-container grid-list-sm>
    <v-layout>
      <v-flex xs12 md6 offset-sm3>
        <v-card :color="$store.state.sysBackgroundColor">
          <EncabezadoCrud
            :titulo="titulo"
            :accion="accion"
            @ejecutarAccion="ejecutarAccion"
          />
          <v-card-text>
            <v-form ref="form">
              <v-layout row wrap>
                <v-flex xs12 md8>
                  <v-text-field
                    ref="controlFoco"
                    label="Nombre*"
                    v-model="itemActivo.Nombre"
                    :rules="[rules.requerido, rules.maximo50]"
                    :readonly="controlSoloLectura"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md2 offset-md2>
                  <v-text-field
                    label="Prefijo*"
                    v-model="itemActivo.Prefijo"
                    v-mask="'####'"
                    :rules="[rules.requerido]"
                    :readonly="controlSoloLectura"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs6 md3>
                  <v-text-field
                    label="Turnos Diarios*"
                    v-model="itemActivo.UltimoTurnoDiario"
                    v-mask="'#'"
                    :rules="[rules.requerido]"
                    :readonly="controlSoloLectura"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 md3>
                  <v-checkbox
                    label="Controlador Fiscal"
                    v-model="itemActivo.ImprimeCF"
                    :readonly="controlSoloLectura"
                  >
                  </v-checkbox>
                </v-flex>
                <v-flex xs6 md3>
                  <v-checkbox
                    label="Factura Electrónica"
                    v-model="itemActivo.ImprimeFE"
                    :readonly="controlSoloLectura"
                  >
                  </v-checkbox>
                </v-flex>
                <v-flex xs6 md3>
                  <v-checkbox
                    label="Comprobantes de Prueba"
                    v-model="itemActivo.HomologacionFE"
                    :readonly="controlSoloLectura"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex>
                  <p>Días Laborables*</p>
                  <v-btn-toggle v-model="diasActivos" multiple>
                    <v-btn v-for="item in diasLaborables" :key="item.Nombre">{{
                      item.Nombre
                    }}</v-btn>
                  </v-btn-toggle>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <PieCrud :loading="loading" />
        </v-card>
      </v-flex>
    </v-layout>
    <GrillaCrud
      :activo="grillaActivo"
      :columnas="grillaColumnas"
      :itemsDB="grillaItems"
      :loading="loading"
      @ejecutarAccion="grillaEjecutarAccion"
      @editarItem="grillaEditarItem"
      @borrarItem="grillaBorrarItem"
    />
    <Mensaje
      :activo="mensajeActivo"
      :tipo="mensajeTipo"
      :titulo="mensajeTitulo"
      :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion"
    />
  </v-container>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import EncabezadoCrud from "@/components/EncabezadoCrud";
import PieCrud from "@/components/PieCrud";
import GrillaCrud from "@/components/GrillaCrud";
import Mensaje from "@/components/Mensaje";
export default {
  name: "PuntoVentaCrud",
  components: {
    EncabezadoCrud,
    PieCrud,
    GrillaCrud,
    Mensaje
  },
  data() {
    return {
      titulo: "Puntos de Venta",
      rutaApi: "PuntoVenta/",
      itemVacio: {
        Id_PuntoVenta: 0,
        Nombre: "",
        Prefijo: 0,
        DiasLaborables: "",
        UltimoTurnoDiario: 0,
        ImprimeCF: 0,
        ImprimeFE: 0,
        HomologacionFE: 0
      },
      itemActivo: {},
      rules: {
        requerido: v => !!v || "Requerido",
        maximo50: v => (v || "").length <= 50 || "Máximo 50 caracteres"
      },
      grillaColumnas: [
        { text: "Nombre", value: "Nombre" },
        { text: "Prefijo", value: "Prefijo" }
      ],
      grillaItems: [],
      grillaActivo: false,
      loading: false,
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      controlSoloLectura: true,
      accion: "",
      diasActivos: [],
      diasLaborables: [
        { Nombre: "Lun.", Activo: false },
        { Nombre: "Mar.", Activo: false },
        { Nombre: "Mié.", Activo: false },
        { Nombre: "Jue.", Activo: false },
        { Nombre: "Vie.", Activo: false },
        { Nombre: "Sáb.", Activo: false },
        { Nombre: "Dom.", Activo: false }
      ]
    };
  },
  computed: {
    iDiasLaborables() {
      let diasLaborables = "";
      for (const element of this.diasActivos)
        diasLaborables += (element + 1).toString();
      return diasLaborables;
    }
  },
  methods: {
    ejecutarAccion(accion) {
      this.accion = accion;
      switch (accion) {
        case "Nuevo":
          this.itemActivo = Object.assign({}, this.itemVacio);
          this.controlSoloLectura = false;
          this.$refs.controlFoco.focus();
          break;
        case "Guardar":
          if (this.$refs.form.validate())
            this.mostrarMensaje(true, "ConfirmacionGuardar", null, null);
          break;
        case "AceptarConfirmacionGuardar":
          this.itemActivo.DiasLaborables = this.iDiasLaborables;
          this.guardarItem(this.itemActivo);
          break;
        case "Abrir":
          this.grillaActivo = true;
          this.grillaItems = [];
          break;
        case "Editar":
          this.grillaActivo = false;
          this.controlSoloLectura = false;
          this.$refs.controlFoco.focus();
          break;
        case "Borrar":
          this.grillaActivo = false;
          this.mostrarMensaje(true, "ConfirmacionBorrar", null, null);
          break;
        case "AceptarConfirmacionBorrar":
          this.borrarItem(this.itemActivo);
          break;
        case "CancelarConfirmacionGuardar":
          this.mostrarMensaje(false);
          break;
        case "CancelarConfirmacionBorrar":
        case "CancelarError":
          this.mostrarMensaje(false);
          this.ejecutarAccion("Inicializar");
          break;
        case "Inicializar":
          this.itemActivo = Object.assign({}, this.itemVacio);
          this.diasActivos = [];
          this.controlSoloLectura = true;
          this.$refs.form.resetValidation();
          break;
      }
    },
    guardarItem(item) {
      this.loading = true;
      HttpHelper.post(this.rutaApi, item)
        .then(() => {
          this.ejecutarAccion("Inicializar");
          this.mostrarMensaje(false);
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    borrarItem(item) {
      this.loading = true;
      HttpHelper.delete(this.rutaApi + item.Id_PuntoVenta)
        .then(() => {
          this.ejecutarAccion("Inicializar");
          this.mostrarMensaje(false);
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaEjecutarAccion(accion, textoBuscado) {
      switch (accion) {
        case "Listar":
          this.grillaListarItems(textoBuscado);
          break;
        case "Cerrar":
          this.grillaActivo = false;
          break;
      }
    },
    grillaListarItems(textoBuscado) {
      this.loading = true;
      this.grillaItems = [];
      HttpHelper.get(this.rutaApi, {
        palabra: textoBuscado
      })
        .then(response => {
          this.grillaItems = response.data;
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaEditarItem(item) {
      this.loading = true;
      HttpHelper.get(this.rutaApi, {
        id: item.Id_PuntoVenta
      })
        .then(response => {
          this.itemActivo = Object.assign({}, response.data);
          this.calcularDiasActivos();
          this.ejecutarAccion("Editar");
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    calcularDiasActivos() {
      this.diasActivos = [];
      if (this.itemActivo.DiasLaborables != null) {
        for (let i = 0; i < this.itemActivo.DiasLaborables.length; i++)
          this.diasActivos.push(
            parseInt(this.itemActivo.DiasLaborables.charAt(i)) - 1
          );
      }
    },
    grillaBorrarItem(item) {
      this.itemActivo = item;
      this.ejecutarAccion("Borrar");
    },
    mostrarError(error) {
      let detalle =
        error.response === undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
